export default {
    tips: {
        no_options: "Ընտրանքներ չեն գտնվել",
        search_by_name: "Որոնել ըստ անվան",
        required: "Այս դաշտը պարտադիր է",
        invalid_email_address: "Էլ. փոստի հասցեն անվավեր է",
        required_field: "պարտադիր դաշտ է",

        mobile_number:
            "Երկրի կոդով հեռախոսահամարը պետք է բաղկացած լինի 8-ից 23 թվանշանից",
        alphabets: "Թույլատրվում են միայն տառեր և թվեր",
        numerics_and_hyphen: "Թույլատրվում են միայն տառեր, թվեր և գծիկ (-)",
        numerics_and_space: "Թույլատրվում են միայն տառեր, թվեր և բացատ",
        country_code_required: "Երկրի կոդը պարտադիր է",
        password_title:
            "Պետք է պարունակի մեծատառ և փոքրատառ տառեր, թվեր և հատուկ նշաններ, և լինի 12-ից 64 նիշ երկարությամբ։",
        numerics_and_underscore: "Թույլատրվում են միայն տառեր, թվեր և ստորակետ (_)",
        dot_and_space: "Թույլատրվում են միայն տառեր, թվեր, բացատ և կետ",
        underscore_and_space:
            "Թույլատրվում են միայն տառեր, թվեր, բացատ և ստորակետ (_)",
        selected_delete_record: "Վստա՞հ եք, որ ցանկանում եք ջնջել ընտրված գրառումը։",
        occurred: "Տեղի ունեցավ սխալ",
        no_record_found: "Գրառում չի գտնվել։",
        no_of_records_rer_page: "Գրառումների քանակը մեկ էջում",
        select_price_period: "Խնդրում ենք ընտրել գնի փոփոխության ժամանակահատվածը",

        outlet_code: "Խնդրում ենք մուտքագրել վաճառքի կետի կոդը",
        country_name: "Խնդրում ենք մուտքագրել երկրի անունը",
        state_name: "Խնդրում ենք մուտքագրել նահանգի/մարզի անունը",
        city_name: "Խնդրում ենք մուտքագրել քաղաքի անունը",
        city_zone: "Խնդրում ենք մուտքագրել քաղաքի գոտին",
        address: "Խնդրում ենք մուտքագրել հասցեն",
        area_code: "Խնդրում ենք մուտքագրել տարածքի կոդը",
        upload_size: "Պատկերի չափը չի կարող գերազանցել 3 ՄԲ-ը",
        enter_number: "Խնդրում ենք մուտքագրել թիվ",
        search_retail_name: "Որոնել մանրածախ հաճախորդի անունով",
        suggest_screen: "Առաջարկվող էկրանի թույլատրելիություն",
        or_higher: "կամ ավելի բարձր",
        repeat_start: "Կրկնության մեկնարկի ժամանակը չի կարող դատարկ լինել",
        endTime_empty: "Կրկնության ավարտի ժամանակը չի կարող դատարկ լինել",
        promotion_not:
            "Ակցիայի ավարտի ժամանակը չի կարող ավելի վաղ լինել, քան մեկնարկի ժամանակը",
        promotion_shall:
            "Ակցիայի ավարտի ժամանակը չպետք է ավելի վաղ լինի, քան մեկնարկի ժամանակը",
        week_no_empty: "Շաբաթը չի կարող դատարկ լինել",
        month_no: "Ամիսը չի կարող դատարկ լինել",
        date_no: "Ամսաթիվը չի կարող դատարկ լինել",
        year_no: "Տարին չի կարող դատարկ լինել",
        overlap: "Ակցիայի և կրկնության ժամանակների միջև համընկնում չկա",
        repetition_time:
            "Ակցիայի և կրկնության ժամանակների միջև համընկնում չկա",
        select_template: "Խնդրում ենք ընտրել ձևանմուշ",
        is_resend: "Կրկին ուղարկե՞լ էկրանին",
        select_at_least: "Խնդրում ենք ընտրել առնվազն 1 տարր",
    },

    common_tips: {
        country_code: "Խնդրում ենք մուտքագրել երկրի կոդը",
        mobile_number: "Խնդրում ենք մուտքագրել հեռախոսահամարը",
        first_name: "Խնդրում ենք մուտքագրել անունը",
        last_name: "Խնդրում ենք մուտքագրել ազգանունը",
        address: "Խնդրում ենք մուտքագրել հասցեն",
        country_name: "Խնդրում ենք մուտքագրել երկրի անունը",
        state_name: "Խնդրում ենք մուտքագրել նահանգի/մարզի անունը",
        city_name: "Խնդրում ենք մուտքագրել քաղաքի անունը",
        start_date: "Խնդրում ենք ընտրել մեկնարկի ամսաթիվը",
        end_date: "Խնդրում ենք ընտրել ավարտի ամսաթիվը",
        operate_fail: "Գործողությունը ձախողվեց",
        select_status: "Խնդրում ենք ընտրել կարգավիճակը"
    },

    tips_retail_client: {
        name: "Խնդրում ենք մուտքագրել մանրածախ հաճախորդի անունը",
        code: "Խնդրում ենք մուտքագրել մանրածախ հաճախորդի կոդը",
        email: "Խնդրում ենք մուտքագրել մանրածախ հաճախորդի էլ. փոստը",
        devices: "Խնդրում ենք մուտքագրել սարքերի քանակը",
        mobile_required: "Հեռախոսահամարը պարտադիր է",

        send_activation: "Վստա՞հ եք, որ ցանկանում եք ուղարկել ակտիվացման նամակը։",
        activation_success: "Ակտիվացման նամակը հաջողությամբ ուղարկվեց",
        created_success: "Հաճախորդը հաջողությամբ ստեղծվեց",
        updated_success: "Հաճախորդը հաջողությամբ թարմացվեց",
        deleted_success: "Հաճախորդը հաջողությամբ ջնջվեց",
        user_exist: "Օգտատերն արդեն գոյություն ունի։",
        given_name: "Նշված անունով հաճախորդն արդեն գոյություն ունի։",
        given_code: "Նշված կոդով հաճախորդն արդեն գոյություն ունի։",

        subscription_start_date_invalid:
            "Անվավեր ամսաթիվ, խնդրում ենք ընտրել բաժանորդագրության մեկնարկի ամսաթիվը։",
        subscription_expire_date_invalid:
            "Անվավեր ամսաթիվ, խնդրում ենք ընտրել բաժանորդագրության ավարտի ամսաթիվը։",
    },

    tips_Template: {
        name: "Խնդրում ենք մուտքագրել ձևանմուշի անունը",
        characters: "Անունը պետք է լինի 51 նիշից պակաս։",
        screen_resolution: "Էկրանի թույլատրելիությունը անվավեր է",
        success: "Ձևանմուշը հաջողությամբ ստեղծվեց",
        updated: "Ձևանմուշը հաջողությամբ թարմացվեց",
        deleted: "Ձևանմուշը հաջողությամբ ջնջվեց",
        not_deleted: "Լռելյայն ձևանմուշը հնարավոր չէ ջնջել",
        sure_delete: "Վստա՞հ եք, որ ցանկանում եք ջնջել ընտրված բաղադրիչները։",
        can_not_deleted: "Ձևանմուշը համաժամեցված է ESL-ի հետ և հնարավոր չէ ջնջել։",
        template_exist: "Նման անունով ձևանմուշ արդեն գոյություն ունի",
    },

    tips_editor: {
        qrCodeColor: "Գույն",
        is_exists: "Տարրն արդեն գոյություն ունի",
        height_than: "Բարձրությունը չպետք է գերազանցի ",
        width_than: "Լայնությունը չպետք է գերազանցի ",
        cannot_add_shape:
            "Հնարավոր չէ ավելացնել պատկեր, երբ կտավի չափին հավասար պատկեր արդեն կա։",
        cannot_add_text:
            "Հնարավոր չէ ավելացնել տեքստ, երբ կտավի չափին հավասար պատկեր արդեն կա։",
        already_added: "Արդեն ավելացված է։",

        cannot_add_image:
            "Հնարավոր չէ ավելացնել պատկեր, երբ կտավի չափին հավասար պատկեր արդեն կա։",
        image_equal:
            "Պատկերի բարձրությունն ու լայնությունը հավասար են, սակայն կտավն արդեն պարունակում է օբյեկտներ։",
        adjusted_exceeds: "Կարգավորված լայնությունը կամ բարձրությունը գերազանցում է կտավի չափերը։",
        canvas_is_empty: "Կտավը դատարկ է։ Ավելացրեք պիտակներ կամ պատկեր։",
        provide_image: "Խնդրում ենք ձևանմուշին ավելացնել պատկեր",
        text_price: "Ես տեքստային հատված եմ",
        dimensions_height: "Բարձրությունը չպետք է գերազանցի կտավի չափերը",
        dimensions_width: "Լայնությունը չպետք է գերազանցի կտավի չափերը",
    },

    tips_openAPI: {
        name: "Խնդրում ենք մուտքագրել անունը",
        company_code: "Խնդրում ենք մուտքագրել ընկերության կոդը",
        company_name: "Խնդրում ենք մուտքագրել ընկերության անունը",
        email: "Խնդրում ենք մուտքագրել էլ. փոստը",
        email_exist: "Նման էլ. փոստն արդեն գոյություն ունի։",
    },

    tips_picture: {
        id: "Խնդրում ենք մուտքագրել նկարի ID-ն",
        name: "Խնդրում ենք մուտքագրել նկարի անունը",
        image_resolution: "Պատկերի թույլատրելիությունը պետք է լինի 400×300 պիքսելից փոքր",
        file_size: "Ֆայլի չափը չի կարող գերազանցել 2 ՄԲ-ը",
        upload_type: "Վերբեռնեք միայն .png, .jpeg, .jpg ֆայլեր",
        character_50: "pictureName-ը չի կարող գերազանցել 50 նիշը",
        character_100: "pictureId-ը չի կարող գերազանցել 100 նիշը",
        character_name: "Անունը չի կարող գերազանցել 100 նիշը",
        pictureId_exist: "Նկարի ID-ն արդեն գոյություն ունի",
        upload_image: "Խնդրում ենք վերբեռնել պատկեր",
        image_size: "Պատկերի չափը պետք է լինի 2 ՄԲ-ից փոքր",
        support_size: "Աջակցվում են .jpeg, .jpg, .png ձևաչափերը",
        resolution_size: "Թույլատրելիությունը պետք է լինի 400×300-ից փոքր",
        success: "Պատկերը հաջողությամբ ստեղծվեց",
        updated: "Պատկերը հաջողությամբ թարմացվեց",
        deleted: "Պատկերը հաջողությամբ ջնջվեց",
    },

    tips_dashboard: {
        than_start_date: "Ավարտի ամսաթիվը պետք է լինի մեկնարկի ամսաթվից ուշ",
        than_from_date: "Ավարտի ամսաթիվը պետք է լինի սկզբնական ամսաթվից ուշ",
        period_date: "Խնդրում ենք ընտրել ավարտի ամսաթիվը",
        period_from_date: "Խնդրում ենք ընտրել սկզբնական ամսաթիվը",
    },

    tips_authorization: {
        name: "Մուտքագրեք լիազորման մակարդակի անունը",
        requires_name: "Անունը պարտադիր է",
        requires_permission: "Թույլտվությունը պարտադիր է",
        role_client_user: "Դերը կապված է հաճախորդի օգտատիրոջ հետ",
        deleted: "Լիազորման մակարդակը հաջողությամբ ջնջվեց",
        created: "Լիազորման մակարդակը հաջողությամբ ստեղծվեց",
        updated: "Լիազորման մակարդակը հաջողությամբ թարմացվեց",
    },

    tips_product: {
        cannot_deleted: "Պիտակը կապված է ապրանքի հետ և հնարավոր չէ ջնջել։",
        last_deleted: "Վերջին պիտակը հնարավոր չէ ջնջել։",
        deleted_product: "Ապրանքի պիտակը հաջողությամբ ջնջվեց",
        added_product: "Ապրանքի պիտակը հաջողությամբ ավելացվեց",
        field_empty: "Այս դաշտը դատարկ է",

        product_name: "Խնդրում ենք մուտքագրել ապրանքի անունը",
        product_sku: "Խնդրում ենք մուտքագրել ապրանքի SKU-ն",
        category_level_1: "Խնդրում ենք մուտքագրել 1-ին կարգի կատեգորիան",
        category_level_2: "Խնդրում ենք մուտքագրել 2-րդ կարգի կատեգորիան",
        category_level_3: "Խնդրում ենք մուտքագրել 3-րդ կարգի կատեգորիան",
        quantity: "Խնդրում ենք մուտքագրել քանակը",
        barcode: "Խնդրում ենք մուտքագրել շտրիխ կոդը",
        product_price: "Խնդրում ենք մուտքագրել ապրանքի գինը",
        discount_price: "Խնդրում ենք մուտքագրել զեղչված գինը",
        brand_name: "Խնդրում ենք մուտքագրել ապրանքանիշի անունը",
        origin_of_product: "Խնդրում ենք մուտքագրել ապրանքի ծագման երկիրը",
        manufacture: "Խնդրում ենք մուտքագրել արտադրողին",
        qr_code: "Խնդրում ենք մուտքագրել QR կոդը",

        choose_excel_file: "Ընտրեք Excel ֆայլ՝ ապրանքները վերբեռնելու համար",
        note_excel_format: "Նշում․ աջակցվում են միայն Xls և Xlsx ձևաչափերը",
        download_excel_format: "Ներբեռնել Excel ֆայլի ձևաչափը",
        add_product_excel: "Ավելացնել ապրանք Excel ֆայլից",
        upload_picture: "Սեղմեք այստեղ՝ պատկեր վերբեռնելու համար",
        country_name: "Խնդրում ենք մուտքագրել երկրի անունը",

        name_character_limit: "Անունը պետք է լինի 51 նիշից պակաս։",
        file_size_limit: "Ֆայլի չափը չի կարող գերազանցել 3 ՄԲ-ը",
        upload_image_format: "(Վերբեռնեք միայն Png, Jpeg, Jpg)",
        quantity_character_limit: "Քանակը չի կարող գերազանցել 6 նիշը",
        category_1_character_limit: "1-ին կատեգորիան պետք է լինի 51 նիշից պակաս։",
        category_2_character_limit: "2-րդ կատեգորիան պետք է լինի 51 նիշից պակաս։",
        category_3_character_limit: "3-րդ կատեգորիան պետք է լինի 51 նիշից պակաս։",
        manufacturer_character_limit:
            "Արտադրողի անունը պետք է լինի 51 նիշից պակաս։",
        origin_character_limit:
            "Ապրանքի ծագման երկիրը պետք է լինի 51 նիշից պակաս։",
        name_required: "Անունը պարտադիր է",
        product_exists: "Նշված անունով ապրանքն արդեն գոյություն ունի։",
        name_character_limit_50: "Անունը պետք է լինի 50 նիշից պակաս։",
        name_special_characters: "Անունը չպետք է պարունակի հատուկ նշաններ։",
        drag_and_drop_file: "Քաշեք և գցեք ֆայլը այստեղ կամ ընտրեք ֆայլ",
        upload_file_format: "(վերբեռնել .png, .jpg)",

        product_deleted_success: "Ապրանքը հաջողությամբ ջնջվեց",
        product_created_success: "Ապրանքը հաջողությամբ ստեղծվեց",
        accept_excel_format: "Թույլատրվում են միայն Excel ֆայլերը։",
        product_updated_success: "Ապրանքը հաջողությամբ թարմացվեց",
        product_change_confirmation:
            "Ապրանքի փոփոխությունը միաժամանակ կփոխի նաև համապատասխան գնապիտակը և գնի փոփոխության իրադարձությունը։<br>Վստա՞հ եք, որ ցանկանում եք փոփոխել ապրանքը։",
        product_delete_confirmation:
            "Ապրանքի ջնջումը միաժամանակ կհեռացնի համապատասխան գնի փոփոխության իրադարձությունները և համաժամեցված գրանցումները։",
        sure_change_product:
            "Ապրանքի փոփոխությունը միաժամանակ կփոխի նաև համապատասխան գնապիտակը և գնի փոփոխության իրադարձությունը։<br>Վստա՞հ եք, որ ցանկանում եք փոփոխել ապրանքը։",
        image_format_incorrect: "Պատկերի ձևաչափը սխալ է",
    },

    tips_outlet: {
        outlet_name: "Խնդրում ենք մուտքագրել վաճառքի կետի անունը",
        outlet_given_name: "Նշված անունով վաճառքի կետն արդեն գոյություն ունի։",
        outlet_given_code: "Նշված կոդով վաճառքի կետն արդեն գոյություն ունի։",
        name_length: "Անունը պետք է լինի 50 նիշից պակաս։",
        code_length: "Կոդը պետք է լինի 30 նիշից պակաս։",
        code_alphanumeric: "Կոդը կարող է պարունակել միայն տառեր և թվեր։",
        code_exceed: "Կոդը չի կարող գերազանցել 30 նիշը։",
        outlet_delete_restricted: "Սարքին կապված վաճառքի կետը հնարավոր չէ ջնջել",
        outlet_deleted: "Վաճառքի կետը հաջողությամբ ջնջվեց։",
        outlet_created: "Վաճառքի կետը հաջողությամբ ստեղծվեց։",
        outlet_updated: "Վաճառքի կետը հաջողությամբ թարմացվեց։",
        select_outlet: "Խնդրում ենք ընտրել վաճառքի կետ",
    },

    tips_user: {
        outlet_in_charge: "Պատասխանատու վաճառքի կետի համար",
        permission_group_name: "Թույլտվությունների խմբի անվանում",
        date_of_joining: "Միանալու ամսաթիվ",
        first_name: "Խնդրում ենք մուտքագրել անունը",
        last_name: "Խնդրում ենք մուտքագրել ազգանունը",
        person_id: "Խնդրում ենք մուտքագրել անձի ID-ն",
        enter_email: "Խնդրում ենք մուտքագրել էլ. փոստը",
        select_date: "ՕՕ-ԱԱ-ՏՏՏՏ (Խնդրում ենք ընտրել ամսաթիվ)",
        first_name_limit: "Անունը չի կարող գերազանցել 100 նիշը",
        allowed_file_types: "Թույլատրվում են միայն *JPEG, *JPG, *PNG",
        max_file_size: "Առավելագույն չափը՝ 3 ՄԲ",
        user_exists: "Օգտատերն արդեն գոյություն ունի։",
        phone_required: "Հեռախոսահամարը պարտադիր է",
        outlet_required: "Վաճառքի կետը պարտադիր է",
        role_required: "Դերը պարտադիր է",
        activation_mail_confirmation: "Վստա՞հ եք, որ ցանկանում եք ուղարկել ակտիվացման նամակը։",
        activation_mail_sent: "Ակտիվացման նամակը հաջողությամբ ուղարկվեց",
        cannot_delete_default_user: "Լռելյայն օգտատիրոջը հնարավոր չէ ջնջել։",
        person_deleted: "Օգտատերը հաջողությամբ ջնջվեց",
        person_created: "Օգտատերը հաջողությամբ ստեղծվեց",
        person_updated: "Օգտատերը հաջողությամբ թարմացվեց",
    },

    tips_gateway: {
        deviceNetworkConfigSteps: "Սարքի ցանցային կարգավորման քայլեր",
        step1PowerUp: "Քայլ 1․ Միացրեք և գործարկեք սարքը",
        step1Description:
            "Եթե սարքը հասանելի ցանց ունի, այն ավտոմատ կմիանա ցանցին և կսկսի աշխատել։",
        step2ConfigureNetwork: "Քայլ 2․ Կարգավորեք ցանցը",
        step2Description:
            "Ցանցը կարող եք կարգավորել Bluetooth-ի միջոցով։ Որոշ սարքեր ունեն նաև սենսորային էկրան, որտեղ Firmware-ում առկա են ցանցային կարգավորումները։",
        step3RestoreFactorySettings: "Քայլ 3․ Վերականգնեք գործարանային կարգավորումները",
        step3Description:
            "Որոշ սարքեր չունեն ցանցի կարգավորումներ։ Այդ դեպքում փորձեք վերականգնել սարքի գործարանային կարգավորումները։",
        readInstructions: "Ես կարդացել եմ այս հրահանգները",

        manualRegisterDevice: "Սարքի ձեռքով գրանցում",
        powerUpAndSetNetwork: "Միացրեք սարքը և կարգավորեք ցանցը",
        step1EthernetConnection:
            "1. Միացրեք ցանցային մալուխը, եթե սարքն աջակցում է Ethernet-ին։",
        step2CommunicationSetting:
            "2. Բացեք սարքի Ethernet/WiFi կարգավորումների ընտրացանկը և անցեք կապի կարգավորումների էջ։ Եթե ցանցը հաջողությամբ կարգավորվի, սարքը սպասման էջում կցուցադրի QR կոդ։",
        step3FindSerialNumber:
            "3. Սարքի սերիական համարը կարող եք գտնել տուփի կողային մասում կամ սարքի հետևի մասում։",
        step4FillSerialNumber: "4. Համակարգում մուտքագրեք սարքի սերիական համարը։",

        specifyDeviceForClient:
            "Խնդրում ենք սարքը կապել մանրածախ հաճախորդի և վաճառքի կետի հետ։",
        syncOutletTimeZone:
            "Այս սարքը կհամաժամեցնի վաճառքի կետի նույն ժամային գոտին։",
        device_does_not: "Սարքը գոյություն չունի։",
        selectFile: "Խնդրում ենք ընտրել ֆայլը",
        versionStartWithV: "Պետք է սկսվի V տառով",
        enterUpgradePackageVersion:
            "Խնդրում ենք մուտքագրել թարմացման փաթեթի տարբերակը, որը սկսվում է 'V' տառով",
        uploadSuccessful: "Վերբեռնումը հաջողությամբ ավարտվեց",
        uploadAndUpgrade: "Վերբեռնել թարմացման փաթեթը և կատարել թարմացում",
        uploadFile: "Վերբեռնել ֆայլ",
        unsupportedType: "Ընթացիկ տեսակը չի աջակցվում",
        fileSizeLimit:
            "Ֆայլի չափը գերազանցում է թույլատրելի սահմանը՝ {{fileSize}} ՄԲ։ Խնդրում ենք վերբեռնել 100 ՄԲ-ից ոչ մեծ ֆայլ։",
        dragOrBrowse: "Քաշեք կամ ընտրեք ֆայլը",
        onlyApkFormat: "Թույլատրվում է միայն apk ձևաչափի ֆայլ",

        searchByDeviceSn: "Որոնել ըստ սարքի սերիական համարի",
        selectYourZone: "Խնդրում ենք ընտրել ձեր գոտին",
        bindZone: "Կապել գոտին",
        enterDeviceSerialNumber: "Խնդրում ենք մուտքագրել սարքի սերիական համարը",
        readInstructionsToAddDevice:
            "Խնդրում ենք կարդալ հրահանգները և նշել վանդակը՝ սարք ավելացնելու համար։",

        deviceUnbindSuccess: "Սարքը հաջողությամբ անջատվեց",
        deviceBindSuccess: "Սարքը հաջողությամբ կապվեց",
        upload_excel_file: "Խնդրում ենք վերբեռնել Excel ֆայլը",
        device_has_been_bound: "Սարքն արդեն կապված է։",
        adv_ground: "Գովազդային խումբ"
    },

    tips_screens: {
        choose_Product_display: "Ընտրեք այն ապրանքը, որը պետք է ցուցադրվի այս էկրանին",
        choose_Template_display: "Ընտրեք այն ձևանմուշը, որը պետք է ցուցադրվի այս էկրանին",
        selected_screen: "Ընտրված էկրան",
        search_by_screenId: "Որոնել ըստ էկրանի ID-ի",
        enter_screen_name: "Խնդրում ենք մուտքագրել էկրանի անունը",
        enter_position_no: "Խնդրում ենք մուտքագրել դիրքի համարը",
        enter_gateway_sn: "Խնդրում ենք մուտքագրել Gateway-ի սերիական համարը",
        template_not_empty: "Ձևանմուշը չի կարող դատարկ լինել",
        product_not_empty: "Ապրանքը չի կարող դատարկ լինել",
        company_id_required: "CompanyId-ը պարտադիր է",
        select_one_screen: "Խնդրում ենք ընտրել էկրան",
        confirm_unbind_device: "Վստա՞հ եք, որ ցանկանում եք անջատել ընտրված սարքը։",
        deviceUn_bind_success: "Սարքը հաջողությամբ անջատվեց",
        screens_sync_success: "Էկրանները հաջողությամբ համաժամեցվեցին",
        select_promotion_StartTime: "Խնդրում ենք ընտրել ակցիայի մեկնարկի ժամանակը",
        select_or_screen: "Խնդրում ենք ընտրել մեկ կամ մի քանի էկրան",
        batch_update_screen_success: "Էկրանների խմբային թարմացումը հաջողությամբ ավարտվեց",
    },

    tips_events: {
        deleted: "Գնի փոփոխության իրադարձությունը հաջողությամբ ջնջվեց",
        created: "Գնի փոփոխության իրադարձությունը հաջողությամբ ստեղծվեց",
        updated: "Գնի փոփոխության իրադարձությունը հաջողությամբ թարմացվեց",
    },

    tips_approval: {
        change_status: "Վստա՞հ եք, որ ցանկանում եք փոխել կարգավիճակը։",
        updated: "Գրառումը հաջողությամբ թարմացվեց",
        not_empty: "Խնդրում ենք ընտրել եզակի արժեք, և այն չպետք է դատարկ լինի։",
        deleted: "Հաստատման հոսքագիծը հաջողությամբ ջնջվեց",
        added: "Հաստատման հոսքագիծը հաջողությամբ ավելացվեց",
        information:
            "Եթե հաստատողներից որևէ մեկը հաստատի, համակարգը տեղեկատվությունը կհամաժամեցնի էկրանին։",
    },

    tips_mobile: {
        mobile_api_management: "Բջջային հավելվածի կառավարում",
        app_name: "Հավելվածի անուն",
        app_version_type: "Հավելվածի տարբերակի տեսակ",
        app_mobile_version: "Հավելվածի տարբերակ",
        is_there_any_update: "Կա՞ թարմացում",
        is_it_a_force_update: "Պարտադիր թարմացում",
        version_name: "Տարբերակի անուն",
        version_number: "Տարբերակի համար",
        type: "Տեսակ",
        update_content: "Թարմացման բովանդակություն",
        update_address: "Թարմացման հասցե",
        actions: "Գործողություններ",
        app_version_type: "Հավելվածի տարբերակի տեսակ",
        app_name_max_length: "Հավելվածի անունը չի կարող գերազանցել 50 նիշը։",
        app_name_required: "Հավելվածի անունը պարտադիր է։",
        type_required: "Տեսակը պարտադիր է։",
        version_number_required: "Տարբերակի համարը պարտադիր է։",
        invalid_version_number: "Տարբերակի համարը անվավեր է։",
        have_update_required: "Թարմացման առկայությունը պարտադիր է։",
        force_update_required: "Պարտադիր թարմացումը պարտադիր է։",
        update_content_required: "Թարմացման բովանդակությունը պարտադիր է։",
        update_address_required: "Թարմացման հասցեն պարտադիր է։",
        successfully_created_app: "Բջջային հավելվածը հաջողությամբ ստեղծվեց։",
        insufficient_privileges: "Անբավարար իրավունքներ։",
        add_new_app: "Ավելացնել նոր հավելված",
        app_name_label: "Հավելվածի անուն",
        app_name_placeholder: "Խնդրում ենք մուտքագրել հավելվածի անունը",
        type_label: "Տեսակ",
        type_placeholder: "Ընտրեք տեսակը",
        version_number_label: "Տարբերակի համար",
        version_number_placeholder: "Խնդրում ենք մուտքագրել տարբերակի համարը",
        have_update_label: "Կա՞ թարմացում",
        have_update_placeholder: "Ընտրեք",
        force_update_label: "Պարտադիր թարմացում",
        force_update_placeholder: "Ընտրեք",
        update_content_label: "Թարմացման բովանդակություն",
        update_content_placeholder: "Խնդրում ենք մուտքագրել թարմացման բովանդակությունը",
        update_address_label: "Թարմացման հասցե",
        update_address_placeholder: "Խնդրում ենք մուտքագրել թարմացման հասցեն",

        edit_new_app: "Խմբագրել հավելվածը",
        edit_name_label: "Հավելվածի անուն",
        edit_name_placeholder: "Խնդրում ենք մուտքագրել հավելվածի անունը",
        type_label: "Տեսակ",
        type_placeholder: "Ընտրեք տեսակը",
        version_number_label: "Տարբերակի համար",
        version_number_placeholder: "Խնդրում ենք մուտքագրել տարբերակի համարը",
        have_update_label: "Կա՞ թարմացում",
        have_update_placeholder: "Ընտրեք",
        force_update_label: "Պարտադիր թարմացում",
        force_update_placeholder: "Ընտրեք",
        update_content_label: "Թարմացման բովանդակություն",
        update_content_placeholder: "Խնդրում ենք մուտքագրել թարմացման բովանդակությունը",
        update_address_label: "Թարմացման հասցե",
        update_address_placeholder: "Խնդրում ենք մուտքագրել թարմացման հասցեն",
        save: "Թարմացնել",
        mobile_app_updated_successFully: "Բջջային հավելվածը հաջողությամբ թարմացվեց",
        app_name_is_required: "Հավելվածի անունը պարտադիր է",
        app_name_can_not_be_greater_then_50_character:
            "Հավելվածի անունը չի կարող գերազանցել 50 նիշը։",
        type_is_required: "Տեսակը պարտադիր է։",
        version_number_is_required: "Տարբերակի համարը պարտադիր է։",
        Invalid_version_number: "Տարբերակի համարը անվավեր է",
        Have_update_is_required: "Թարմացման առկայությունը պարտադիր է",
        Force_Update_is_required: "Պարտադիր թարմացումը պարտադիր է",
        Update_content_is_required: "Թարմացման բովանդակությունը պարտադիր է։",
        Update_address_is_required: "Թարմացման հասցեն պարտադիր է։",
        Android: "ANDROID",
        Ios: "IOS",
        Force_Update_required: "Պարտադիր",
        Force_Update_not_required: "Պարտադիր չէ",
        Any_Update_Yes: "ԱՅՈ",
        Any_Update_No: "ՈՉ",
        Mobile_version_deleted_successfully: "Բջջային հավելվածի տարբերակը հաջողությամբ ջնջվեց",
        Delete_conformation: "Ջնջման հաստատում",
        Enter_the_name: "Մուտքագրեք անունը",
    },
};
